var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('el-avatar',{staticClass:"el-dropdown-link",style:({'margin-top':'8px'})},[_vm._v(" "+_vm._s(this.$store.state.a.info.username))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }